export const SEARCH_REQUEST = '@search/SEARCH_REQUEST';
export const SEARCH_SUCCESS = '@search/SEARCH_SUCCESS';
export const SEARCH_FAILURE = '@search/SEARCH_FAILURE';
export const SEARCH_DONE = '@search/SEARCH_DONE';

export const CLEAR_ERROR = '@search/CLEAR_ERROR';
export const CLEAR_DONE = '@search/CLEAR_DONE';
